import type { ApolloClient, NormalizedCacheObject } from '@apollo/client';
import { createContext } from 'react';

export interface ContentClientContextValues {
    contentClient?: ApolloClient<NormalizedCacheObject>;
    companySlug?: string;
}

const ContentClientContext = createContext<ContentClientContextValues>({
    contentClient: undefined,
    companySlug: '',
});

export default ContentClientContext;
